import React, { Component } from 'react';
import translate from './TranslateHOC';
import { programmeTitle } from '../helpers';
import Isvg from 'react-inlinesvg';
import facebook from '../img/icons/circle_facebook.svg';
import twitter from '../img/icons/circle_twitter.svg';
import email from '../img/icons/email.svg';
import whatsapp from '../img/icons/whatsapp.svg';

import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  WhatsappShareButton,
} from 'react-share';
import { isMobile } from 'react-device-detect';

class ProgrammeActionsShare extends Component {
  render() {
    const { prog, strings } = this.props;
    const pathName = window.location.pathname
      .split('/')
      .filter((val) => val !== '')[0];
    var sharePath =
      window.location.protocol +
      '//' +
      window.location.host +
      '/' +
      pathName +
      '/programme/' +
      prog.id;
    const shareUrl = sharePath;

    let title;
    if (prog.title) {
      title = `${prog.title} - ${prog.subTitle}`;
    } else {
      const progTitles = programmeTitle(
        prog.series_title,
        prog.programme_title,
        prog.clic_aired
      );
      title = `${progTitles.title} - ${progTitles.subTitle}`;
    }

    return (
      <ul className="dialog__share-list">
        <li className="dialog__share-item">
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            className="dialog__share-button dialog__share-button--facebook"
          >
            <Isvg src={facebook} />
            <span className="screen-reader-text">{strings.shareFacebook}</span>
            <p>Facebook</p>
          </FacebookShareButton>
        </li>
        <li className="dialog__share-item">
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="dialog__share-button dialog__share-button--twitter"
          >
            <Isvg src={twitter} />
            <span className="screen-reader-text">{strings.shareTwitter}</span>
            <p>Twitter</p>
          </TwitterShareButton>
        </li>
        <li className="dialog__share-item">
          <EmailShareButton
            subject={title}
            body={shareUrl}
            className="dialog__share-button dialog__share-button--email"
          >
            <Isvg src={email} />
            <span className="screen-reader-text">{strings.shareEmail}</span>
            <p>{strings.socialEmail}</p>
          </EmailShareButton>
        </li>
        {isMobile && (
          <li className="dialog__share-item">
            <WhatsappShareButton
              url={shareUrl}
              title={title}
              className="dialog__share-button dialog__share-button--whatsapp"
            >
              <Isvg src={whatsapp} />
              <span className="screen-reader-text">
                {strings.shareWhatsapp}
              </span>
              <p>Whatsapp</p>
            </WhatsappShareButton>
          </li>
        )}
      </ul>
    );
  }
}

export default translate(ProgrammeActionsShare);
